import { useEffect, useState } from 'react';

import NewConfig from '../../../assets/newconfig.svg';
import { CustomButtonWithIcon } from '../../../components/Buttons/CustomButtonWithIcon';
import { DontExistsItem } from '../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../components/DontExistsItem/styles';
import { ListAppConfigurations } from '../../../components/List/Collects/ListAppConfigurations';
import { ListConfigurations } from '../../../components/List/ListConfiguration';
import { LoadingData } from '../../../components/LoadingData';
import { EditOneAppConfiguration } from '../../../components/Modal/EditOneAppConfiguration';
import { InfoConfiguration } from '../../../components/Modal/InfoConfiguration';
import { PageHeader, ViewMode } from '../../../components/PageHeader';
import { useConfiguraionContext } from '../../../context/ProviderPage/Configuration';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';

const Configuracoes = () => {
  const [modifyViewMode, setModifyViewMode] = useState<ViewMode>({
    have: true,
    mode: 'card',
  });
  const { setSelectedPage } = usePageContext();
  const {
    loadConfigurationsAction,
    configurations,
    loadingConfigurations,
    openCreateNewConfiguration,
    openAndCloseCreateNewConfiguration,
  } = useConfiguraionContext();

  useEffect(() => {
    setSelectedPage({ option: 'configuracoes' });
    loadConfigurationsAction();
  }, []);

  return (
    <>
      <PageHeader
        {...{
          pageIcon: { option: 'configuracoes' },
          pageTitle: 'Configurações do App',
          hasFilter: false,
          button: (
            <CustomButtonWithIcon
              {...{
                width: 180,
                action: openAndCloseCreateNewConfiguration,
                icon: NewConfig,
                title: 'Nova Configuração',
              }}
            />
          ),
          modifyViewMode,
          setModifyViewMode,
        }}
      />
      <ContainerPage>
        <PageContent
          style={{
            justifyContent: 'flex-start',
          }}
        >
          {loadingConfigurations ? (
            <LoadingData title="Buscando dados" />
          ) : (
            <>
              {configurations.length === 0 ? (
                <DontExistsItemFlex>
                  <DontExistsItem title="Nenhuma configuração disponível no momento" />
                </DontExistsItemFlex>
              ) : (
                <>
                  {modifyViewMode.mode === 'normal' ? (
                    <ListConfigurations data={configurations} />
                  ) : (
                    <ListAppConfigurations data={configurations} />
                  )}
                </>
              )}
            </>
          )}
        </PageContent>
        <InfoConfiguration
          {...{
            isOpen: openCreateNewConfiguration,
            closeModal: openAndCloseCreateNewConfiguration,
            option: 'configuracoes',
            titleModal: 'Nova Configuração',
          }}
        />
        <EditOneAppConfiguration
          {...{
            option: 'configuracoes',
            titleModal: 'Editar Configuração',
          }}
        />
      </ContainerPage>
    </>
  );
};

export { Configuracoes };
